module.exports = __webpack_public_path__ + "static/media/close-icon.c18edb83.svg";